import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import AboutSection, { BenefitsSection, SafetySection, ArticleSection } from '@/pages/home/components/ContentSections';
import FAQSection from '@/pages/home/components/FAQSection';

const siteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "kakobuypolska.site",
  "url": "https://kakobuypolska.site",
  "description": "Kakobuy Spreadsheet Polska – największa baza znalezisk Kakobuy w Polsce. Sprawdź aktualne linki do produktów, poradniki zakupowe, porównania jakości oraz bezpieczne wskazówki.",
  "inLanguage": "pl-PL",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://kakobuypolska.site/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "kakobuypolska.site",
  "url": "https://kakobuypolska.site",
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
  "description": "Niezależne źródło informacji o Kakobuy Spreadsheet. Nie jesteśmy oficjalnie powiązani z platformą Kakobuy.",
  "foundingDate": "2026",
  "areaServed": { "@type": "Country", "name": "Polska" }
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Czym dokładnie jest Kakobuy Spreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Kakobuy Spreadsheet to starannie przygotowany arkusz kalkulacyjny zawierający setki linków do najlepszych produktów dostępnych na platformie Kakobuy. Zawiera on kategorie takie jak buty, odzież, akcesoria i wiele więcej, wraz z ocenami jakości i rekomendacjami społeczności."
      }
    },
    {
      "@type": "Question",
      "name": "Czy korzystanie z Kakobuy Spreadsheet jest darmowe?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy go jako narzędzie pomocnicze dla społeczności, aby ułatwić wyszukiwanie najlepszych produktów na platformie Kakobuy."
      }
    },
    {
      "@type": "Question",
      "name": "Jak często aktualizowany jest arkusz?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Arkusz jest regularnie aktualizowany, aby zapewnić dostęp do najnowszych i najbardziej aktualnych linków do produktów. Nowe znaleziska są dodawane, a nieaktualne linki są usuwane na bieżąco."
      }
    },
    {
      "@type": "Question",
      "name": "Czy mogę ufać produktom z arkusza?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Wszystkie produkty w arkuszu zostały zweryfikowane przez społeczność. Zawsze jednak zalecamy sprawdzenie ocen sprzedawcy, poproszenie o zdjęcia QC oraz dokładne przeczytanie opisów produktów przed dokonaniem zakupu."
      }
    },
    {
      "@type": "Question",
      "name": "Jakie kategorie produktów zawiera arkusz?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Arkusz zawiera szeroki wybór kategorii, w tym buty (sneakersy), odzież (bluzy, koszulki, kurtki, spodnie), akcesoria (torby, paski, czapki), perfumy, bieliznę oraz wiele innych kategorii produktowych."
      }
    },
    {
      "@type": "Question",
      "name": "Czy Kakobuy Spreadsheet działa w Polsce?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Tak, Kakobuy Spreadsheet jest w pełni dostępny dla użytkowników z Polski. Platforma Kakobuy obsługuje wysyłkę do Polski, a nasz arkusz jest zoptymalizowany pod kątem polskich użytkowników i ich preferencji zakupowych."
      }
    }
  ]
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}></script>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutSection />
        <BenefitsSection />
        <SafetySection />
        <ArticleSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}